<div>

  <div class="flex align-items-center w-full mt-3" style="position: relative;">
    <div class="flex align-items-center gap-2" style="position: absolute; left: 50%; transform: translateX(-50%);">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class="p-inputtext-sm"
          (keyup.enter)="searchVendor()"  style="height: 35px; padding-left: 2rem; font-size: 0.875rem;"/> 
      </span>

      <p-button icon="pi pi-search" (onClick)="searchVendor()"
          styleClass="custom-btn" [raised]="true" [size]="'small'"
          severity="info"></p-button>
    </div>
  
    <div class="ml-auto"> 
      <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info"
        styleClass="custom-btn">
      </p-button>
    </div>
  </div>

  <p-table #dt1 [value]="vendorList"  [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped"
    responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="5"
    selectionMode="single" (onPage)="load($event)" (onRowSelect)="SelectOption($event)"
    [rowsPerPageOptions]="[5, 10, 20]"  [loading]="loader">

    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Vendor Code</th>
        <th>Vendor Name</th>
        <th>City</th>
        <th>State</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-vendor>
      <tr (click)="SelectOption(vendor)">
        <td>
          <p-tableRadioButton [value]="vendor"></p-tableRadioButton>
        </td>
        <td>{{vendor.vendorCode}}</td>
        <td>{{vendor.vendorName}}</td>
        <td>{{vendor.address?.city}}</td>
        <td>{{vendor.address?.state}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>